import { Component, OnInit } from "@angular/core";
import { ProductAnalyticService } from "../../../shared/product-analytic/product-analytic";
declare var mixpanel;
@Component({
  selector: "app-login",
  template: `hello
    <div class="full-page-overlay">
      <div class="rfqLoader"></div>
    </div>`,
})
export class LogoutComponent implements OnInit {
  constructor(private productAnalyticService: ProductAnalyticService) {}

  ngOnInit(): void {
    this.productAnalyticService.hotjarClearUser();
    browserWindow.setTimeout(function () {
      if (mixpanel?.cookie && mixpanel?.cookie?.clear) {
        if (mixpanel?.reset) {
          mixpanel.reset();
        }
        mixpanel.cookie.clear();
      }
    }, 200);
    AppStorageUtil.clearCookies();
    AppStorageUtil.clear();
    AppStorageUtil.clearSession();
    AppStorageUtil.clearSupplierDynamicTilesIntentScoringLocalStorage(); // TEMP-SUPPLIER-DASHBOARD-TILES-TEST: remove with BrowserStorageUtil helpers
    browserWindow.location.href = "/";
  }
}
